<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/trgI0B/tc-custom/9781398432642.jpg?1705541262118" alt="This image is the cover for the book Practical Management Skills"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Practical Management Skills
      </h1>
      <p class="bookDescription body article font2">
        <p>The author has been a manager for longer than she has been a mother and a wife. Thankfully, no one carries out an annual review on your performance as a wife or a mother, yet you are constantly evaluated when you are a manager. Therefore, it is crucial to understand and focus on the criteria that make you a successful manager. For her, a successful manager is one who is able to gain respect, build a strong team, retain talent, develop people, manage others and work well within a team of other managers. These goals thus make up the backbone of this book. <br/>The genesis of the book came whilst the author was on a maternity leave, when she found herself searching for a hobby that would draw on her strengths and address something that she was personally invested in. After being a manager for a decade, she realised that her passion lay in teaching others how to become better managers and progress their careers, as much as it did with her own ongoing learning and development as a manager. <br/>Although the author's decade of management experience comes from the financial sector, she strongly believes that her teachings are applicable to all industries. English is her third language and writing a book is a new venture for her; however, she thinks that this actually works to the benefit of the book as she uses simple, jargon-free language that helps any readers to easily grasp the managerial concepts raised. The book therefore makes an easy read, whether it is read from beginning to an end, or dipped into to address specific themes that the reader may want to turn to, depending on which part of their managerial experience they currently need help with. <br/>The author hopes the reader finds the book engaging and interesting as well as educational.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ksenia Bure
      </h2>
      
      <p class="authorDescription body article">Ksenia Bure was born in Latvia, when it was still part of the Soviet Union and lived in Latvia until the age of 13, before attending Clifton College boarding school, in the UK. Without speaking English at first, transition to UK was an experience and it was not the last time Ksenia had to make cultural adjustments. As part of her Bachelor degree, German with Management studies, in University College London, Ksenia lived a year abroad in Germany, learning German and writing a dissertation on Jewish Survivors living in Berlin. Upon graduating, Ksenia joined Bloomberg LP and has worked in both London Headquarters and relocated to New York, covering different territories. Ksenia has worked at Bloomberg for 14 years, currently running its EMEA Data and Technology Sales business. Ksenia is married and has a daughter residing in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ac36d70